<script setup>
import Dialog from 'primevue/dialog'
import Button from 'primevue/button'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  productType: {
    type: Object,
    default: null
  },
  deleting: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['close', 'confirm'])

function closeDialog() {
  if (props.deleting) return
  emit('close')
}

function confirmDelete() {
  emit('confirm')
}
</script>

<template>
  <Dialog
    :visible="props.visible"
    modal
    header="Подтверждение удаления"
    :style="{ width: 'min(460px, 95vw)' }"
    :closable="!props.deleting"
    @update:visible="closeDialog"
  >
    <div class="confirm-content">
      <p>
        Вы действительно хотите удалить основной товар
        <strong>{{ props.productType?.name || '—' }}</strong>?
      </p>

      <p class="warning-text">
        Если к типу товара привязаны продукты, удаление может быть запрещено.
      </p>
    </div>

    <template #footer>
      <Button
        label="Отмена"
        severity="secondary"
        outlined
        :disabled="props.deleting"
        @click="closeDialog"
      />

      <Button
        label="Удалить"
        icon="pi pi-trash"
        severity="danger"
        :loading="props.deleting"
        :disabled="props.deleting"
        @click="confirmDelete"
      />
    </template>
  </Dialog>
</template>

<style scoped>
.confirm-content {
  font-size: 15px;
  line-height: 1.5;
}

.warning-text {
  color: #b45309;
  margin-top: 10px;
}
</style>